/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useUsersGet = makeQueryHook(operations.usersGet)

export const useUserCreate = makeMutationHook(operations.userCreate)

export const useUserGet = makeQueryHook(operations.userGet)

export const useUserUpdate = makeMutationHook(operations.userUpdate)

export const useUserRoleGet = makeQueryHook(operations.userRoleGet)

export const useUserRoleUpdate = makeMutationHook(operations.userRoleUpdate)

export const useUserRoleDelete = makeMutationHook(operations.userRoleDelete)

export const useUserGetPermissions = makeQueryHook(
  operations.userGetPermissions,
)

export const useInternalUsersGet = makeQueryHook(operations.internalUsersGet)

export const useInternalUserCreate = makeMutationHook(
  operations.internalUserCreate,
)

export const useInternalUserGet = makeQueryHook(operations.internalUserGet)

export const useInternalUserUpdate = makeMutationHook(
  operations.internalUserUpdate,
)

export const useInternalUserGetPermissions = makeQueryHook(
  operations.internalUserGetPermissions,
)

export const useInternalUserRoleGet = makeQueryHook(
  operations.internalUserRoleGet,
)

export const useInternalUserRoleUpdate = makeMutationHook(
  operations.internalUserRoleUpdate,
)

export const useInternalUserRoleDelete = makeMutationHook(
  operations.internalUserRoleDelete,
)
